module.exports = __webpack_public_path__ + "static/media/icon-contact2.44c0d5c6.svg";